import { Box, Popover } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import PositionTagPopover from './PositionTagPopover'
import UserTagPopover from './UserTagPopover'

type CommentTagProps = {
  type: 'user' | 'position'
  id: string
  name: string
  documentId: string
}

export default function CommentTag({
  type,
  id,
  name,
  documentId,
}: CommentTagProps) {
  const overlay = useOverlay()

  return (
    <>
      <Box
        component="button"
        type="button"
        aria-haspopup="dialog"
        aria-expanded={overlay.isOpen}
        onClick={overlay.open}
        sx={{
          all: 'unset',
          cursor: 'pointer',
          color: 'primary.main',
          fontWeight: 500,
          borderRadius: 0.5,
          '&:hover': { textDecoration: 'underline' },
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'primary.main',
          },
        }}
      >
        @{name}
      </Box>
      <Popover
        open={overlay.isOpen}
        anchorEl={overlay.anchorEl as Element}
        onClose={overlay.close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        slotProps={{ paper: { role: 'dialog', 'aria-label': name } }}
      >
        <Box sx={{ minWidth: 200, maxWidth: 280, p: 2 }}>
          {type === 'user' ? (
            <UserTagPopover userId={id} name={name} open={overlay.isOpen} />
          ) : (
            <PositionTagPopover
              positionId={id}
              documentId={documentId}
              name={name}
              open={overlay.isOpen}
            />
          )}
        </Box>
      </Popover>
    </>
  )
}
